import styled from "@emotion/styled";

import { BasicFlex } from "../../../utils/Common";

import { useFormData } from "../../../contexts/FormData";

import { useFormikContext } from "formik";

import { useQuery } from "@tanstack/react-query";

import { getAllTasks } from "../../Repair_Tickets/apiService";

import { groupBy } from "lodash";

import { Card, CardContent, CardHeader, Divider, Tooltip, IconButton } from "@mui/material";

import WigIcon from "../../../images/WigIcon";

import SubdirectoryArrowRightRoundedIcon from '@mui/icons-material/SubdirectoryArrowRightRounded';
import UpdateRoundedIcon from '@mui/icons-material/UpdateRounded';


import DownloadButton from "../../../utils/utilities/Buttons/DownloadButton";

const WigIconBox = styled.div`
  height: 1.5rem;
  width: 1.5rem;
`

const RepairListContainer = styled(BasicFlex)`
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

const TaskTitle = styled.div`
  font-weight: 600;
  color: ${props => props.theme.colors.mildText};
`

const RepairList = () => {

  const { values } = useFormikContext() || {};

  const { formValues } = useFormData() || {};

  let repairs = values?.repairs

  let ids = repairs?.map(repair => repair?.repair_task_id)

  const { data: repair_tickets } = useQuery({
    queryKey: ["repair_tickets", ids],
    queryFn: () => getAllTasks(ids),
    enabled: !!ids?.length
  })

  let list = groupBy(repair_tickets, "repair_ticket_num");

  return (
    <RepairListContainer dir="column">
      {Object.entries(list).map(([repair, tickets], index) => (
        <Card sx={{width: "100%", borderRadius: "8px", borderColor: "info.light", borderWidth: "2px"}} variant="outlined" key={repair}>
          <CardHeader title={`Repair Ticket #${repair}`}
          subheader={<BasicFlex justify="flex-start" gap=".6rem"><WigIconBox><WigIcon /></WigIconBox> {tickets?.[0].wig_id}</BasicFlex>}
           sx={{p: 1}} 
           action={(
           <BasicFlex>
            <Tooltip title="Schedule Follow Up">
              <IconButton disabled>
                <UpdateRoundedIcon color="warning.light" />
              </IconButton>
            </Tooltip>
            <DownloadButton title="Print Repair Ticket" url={`/repair_tickets/generate/all_slips/${tickets?.[0]?.repair_ticket_id}`} />
           </BasicFlex>
          )}
           slotProps={{
            title: {
             sx: {
               fontSize: "1.4rem",
               fontWeight: "400",
               textTransform: "uppercase"
             }
           },
           subheader: {
             sx: {
               fontSize: "1.2rem",
             }
           }
          }}
           />
           <Divider />
          <CardContent sx={{p: 1, pb: "1rem !important"}}>
            {tickets?.map(ticket => (
              <BasicFlex key={ticket.repair_ticket_id} justify="flex-start" gap=".6rem"><SubdirectoryArrowRightRoundedIcon fontSize="small" color="basic" /><TaskTitle>{ticket.repair_name}</TaskTitle></BasicFlex>
            ))}
          </CardContent>
        </Card>
      ))}
    </RepairListContainer>
  )

};

export default RepairList;